import * as React from "react";

const SvgReport = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path d="M805 5108 c-89 -16 -204 -80 -278 -153 -77 -76 -138 -190 -156 -289
-15 -83 -15 -4129 0 -4212 38 -212 231 -405 443 -443 83 -15 3409 -15 3492 0
99 18 213 79 289 156 76 76 137 190 154 287 8 41 11 605 11 1788 0 1441 -2
1734 -14 1761 -16 38 -1082 1086 -1123 1104 -35 15 -2738 16 -2818 1z m2605
-626 c0 -201 4 -362 11 -397 22 -119 93 -210 204 -262 l60 -28 388 -3 387 -3
-2 -1652 -3 -1652 -22 -40 c-25 -47 -74 -95 -123 -121 -34 -18 -97 -19 -1750
-19 -1653 0 -1716 1 -1750 19 -49 26 -98 74 -123 121 l-22 40 0 2075 c0 2005
1 2076 19 2110 36 68 97 120 166 141 14 4 595 8 1293 8 l1267 1 0 -338z m755
-311 l80 -81 -248 0 c-234 0 -248 1 -267 20 -19 19 -20 33 -20 261 l0 241 188
-180 c103 -99 223 -217 267 -261z"/>
<path d="M1420 2722 c-107 -53 -107 -211 0 -264 33 -17 107 -18 1123 -18 1205
0 1131 -4 1180 64 31 43 31 129 0 172 -49 68 25 64 -1180 64 -1016 0 -1090 -1
-1123 -18z"/>
<path d="M1420 2122 c-107 -53 -107 -211 0 -264 33 -17 98 -18 928 -18 989 0
937 -3 985 64 31 43 31 129 0 172 -48 67 4 64 -985 64 -830 0 -895 -1 -928
-18z"/>
<path d="M1420 1522 c-50 -25 -80 -75 -80 -132 0 -57 30 -107 80 -132 33 -17
103 -18 1034 -18 l998 0 39 22 c41 23 79 84 79 128 0 44 -38 105 -79 128 l-39
22 -998 0 c-931 0 -1001 -1 -1034 -18z"/>
    </g>
  </svg>
);

export default SvgReport;
